import React, { useEffect, useState } from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";

export default function StockKeeperProductViewPage() {
    const { id } = useParams();
    const location = useLocation();
    const [product, setProduct] = useState(location.state?.item || null);

    useEffect(() => {
        // If state isn't available, you could fetch product detail via API endpoint here if needed
    }, [id]);

    if (!product) {
        return (
            <PageLayout>
                <div className="text-center py-5">
                    <h3>Product details not found.</h3>
                    <Link to="/stock-keeper-products" className="btn btn-primary mt-3">Back to List</Link>
                </div>
            </PageLayout>
        );
    }

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card mb-4 d-flex justify-content-between align-items-center">
                        <h3>Product Detail: {product.product_code}</h3>
                        <Link to="/stock-keeper-products" className="btn btn-secondary btn-sm">Back</Link>
                    </div>
                </Col>

                <Col md={8}>
                    <Card className="mc-card mb-4">
                        <Card.Body>
                            <h4 className="mb-3">{product.title}</h4>
                            <p><strong>Product Code:</strong> {product.product_code}</p>
                            <p><strong>Category:</strong> {product.category?.name || "N/A"}</p>
                            <p><strong>Brand:</strong> {product.brand?.name || "N/A"}</p>
                            <p><strong>Selling Price:</strong> ${product.sell_price_dollar}</p>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={4}>
                    <Card className="mc-card mb-4">
                        <Card.Body>
                            <h5 className="mb-3">Product Images</h5>
                            <div className="d-flex flex-column gap-3">
                                {product.images && product.images.length > 0 ? (
                                    product.images.map((img, idx) => (
                                        <img
                                            key={idx}
                                            src={`${process.env.REACT_APP_IMG_URL}${img.image}`}
                                            alt="Product"
                                            className="img-fluid rounded border"
                                            style={{ maxHeight: "200px", objectFit: "cover" }}
                                        />
                                    ))
                                ) : (
                                    <p className="text-muted">No images available.</p>
                                )}
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </PageLayout>
    );
}